var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read"},[_c('iframe',{attrs:{"src":'https://view.officeapps.live.com/op/view.aspx?src=' + _vm.url,"width":"100%","height":"100%","frameborder":"1"}})])}
var staticRenderFns = []

export { render, staticRenderFns }